export const loginExemptPageList: string[] = [
  '/logIn',
  '/resetPassword',
  '/terms/terms',
  '/terms/privacy'
]
